/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */

export type GetApiVendorPropertiesListSortBy = typeof GetApiVendorPropertiesListSortBy[keyof typeof GetApiVendorPropertiesListSortBy] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetApiVendorPropertiesListSortBy = {
  submittedAt: 'submittedAt',
  fullAddress: 'fullAddress',
  id: 'id',
} as const;
